namespace $.$$ {
	$mol_style_define($shm_hitalama_benchmarks_page_metrics_details, {
		Trigger: { padding: { top: '0.25rem', bottom: '0.25rem', left: '0.5rem', right: '0.5rem' }, minWidth: '2rem', minHeight: '2rem' },
		Bubble: { maxHeight: '80vh', overflow: 'auto' },
		Text: { flex: { direction: 'column' }, width: '32rem' },
		Computer_label: { minWidth: 0, Content: { minWidth: 0 } },
		Browser_label: { minWidth: 0, Content: { minWidth: 0 } },
		Computer_value: { display: 'block', minWidth: 0, width: '100%', flex: { shrink: 1 }, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' },
		Browser_value: { display: 'block', minWidth: 0, width: '100%', flex: { shrink: 1 }, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' },
	})
}
